module.exports = __webpack_public_path__ + "img/paperclip-solid.030ba368.svg";